import { useNavigate } from "react-router";
import { Card, EmptyState } from "../components/primitives";

export function NoAgentsPage() {
  const navigate = useNavigate();

  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
    }}>
      <Card style={{ maxWidth: 400, textAlign: "center" }}>
        <EmptyState>
          This workspace is empty. Create your first agent to get started.
        </EmptyState>
        <div style={{ marginTop: 16 }}>
          {/* Sprint 23.5 — replaces the old NewAgentModal with the conversational
              composition wizard at /hire. */}
          <button data-variant="primary" onClick={() => navigate("/hire")}>
            Hire your first agent
          </button>
        </div>
      </Card>
    </div>
  );
}
